"use client";

import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import dynamic from "next/dynamic";

import styles from "./styles.module.css";

const GptAd = dynamic(() => import("components/gpt-ad-element"), { ssr: false });

const TopAdBanner = ({ pageUrl }) => {
  const [isError, setIsError] = useState(false);

  const isListingPage =
    /^\/(satilik|kiralik|kat-karsiligi|devren|gunluk-kiralik)-/.test(pageUrl) &&
    !/[?&]view_type=map($|&)/.test(pageUrl);

  useEffect(() => {
    if (!isListingPage) return;

    const observer = new MutationObserver(() => {
      const pageNotFoundMessage = document.body.innerText;
      if (pageNotFoundMessage.includes("Üzgünüz, aradığınız sayfayı bulamadık.")) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    isListingPage &&
    !isError && (
      <div className={styles.adBanner}>
        <GptAd elementId="div-gpt-ad-1733492200314-0" closable />
      </div>
    )
  );
};

TopAdBanner.propTypes = {
  pageUrl: PropTypes.string,
};

export default TopAdBanner;
